import { render, staticRenderFns } from "./merchantStoreIndex.vue?vue&type=template&id=2b822cd9&scoped=true&"
import script from "./merchantStoreIndex.vue?vue&type=script&lang=js&"
export * from "./merchantStoreIndex.vue?vue&type=script&lang=js&"
import style0 from "./merchantStoreIndex.vue?vue&type=style&index=0&id=2b822cd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b822cd9",
  null
  
)

export default component.exports